import React, { Component } from "react"
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import PropTypes from "prop-types"
import { fetchBranch } from "../actions/branchActions"
import { BranchInfo, Map } from "../components/CompanyInfo"
import LoadingSpinner from "../components/LoadingSpinner"
import RibbonContainer from "../components/RibbonContainer"
import PersonnelInfos from "../components/CompanyInfo/PersonnelInfos"
import Styles from "./Company.module.css"
import { Seo } from "../components/Seo"

class Branch extends Component {
  static contextTypes = {
    router: () => true,
  }

  state = {
    personnelInfoYear: null,
    personnelInfoYearOptions: null,
  }

  componentDidMount() {
    const { match, getBranch } = this.props
    const { branchId } = match.params
    if (branchId) getBranch(branchId)
    window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps) {
    if (this.props.branch !== prevProps.branch) {
      this.getPersonnelInfoYears()
    }
  }

  onChangePersonnelInfoYear = personnelInfoYear => this.setState({ personnelInfoYear })
  getPersonnelInfoYears = () => {
    const { branch } = this.props
    const yearOptions = [...(branch?.company?.personnelInfos || [])]
      .sort((a, b) => a.tilinpaatos_vuosi - b.tilinpaatos_vuosi)
      .map((personnelInfo, index) => ({ value: index, label: personnelInfo.tilinpaatos_vuosi }))
    this.setState({
      personnelInfoYear: yearOptions[yearOptions.length - 1],
      personnelInfoYearOptions: yearOptions,
    })
  }

  renderPersonnelInfo = () => {
    const { branch } = this.props
    const { personnelInfoYear, personnelInfoYearOptions } = this.state
    if (branch?.company?.personnelInfos?.length && personnelInfoYear) {
      return (
        <PersonnelInfos
          selectedYear={personnelInfoYear}
          allPersonnelInfos={[...branch.company.personnelInfos].sort(
            (a, b) => a.tilinpaatos_vuosi - b.tilinpaatos_vuosi
          )}
          yearOptions={personnelInfoYearOptions}
          onChange={this.onChangePersonnelInfoYear}
        />
      )
    }
  }

  renderMap = branch => {
    if (!branch.latitude || !branch.longitude) return null
    return <Map markers={[branch]} showPopup />
  }

  renderBranch = () => {
    const { branch } = this.props

    if (Object.keys(branch).length === 0) {
      return <h1 className={Styles.notFound}>Sivutoimipaikkaa ei löydy</h1>
    }
    const hasPersonnelInfo = branch?.company?.personnelInfos?.length
    return (
      <div className={Styles.companyPage}>
        <BranchInfo branch={branch} />
        <RibbonContainer title='Tilinpäätöstiedot'>
          <p className={Styles.infoText}>
            Liikevaihtotietoja ei ole saatavilla sivutoimipaikoille. Tilinpäätöksen mukaiset tiedot näytetään vain päätoimipaikoille.
          </p>
        </RibbonContainer>
        {hasPersonnelInfo ? this.renderPersonnelInfo() : null}
        {this.renderMap(branch)}
      </div>
    )
  }

  renderBackButton = () => {
    const { location, history } = this.props
    if (location.state && location.state.prevPath === "/") {
      return (
        <div className={Styles.backButton}>
          <Link
            to={{
              pathname: "/",
              state: { prevPath: location.pathname },
            }}
          >
            ← Takaisin etusivulle
          </Link>
        </div>
      )
    }
    if (
      (location.state && location.state.prevPath.includes("/haku/")) ||
      (location.state && location.state.prevPath.includes("/top500/"))
    ) {
      return (
        <div className={Styles.backButton}>
          <button type="button" onClick={history.goBack}>
            ← Takaisin hakuun
          </button>
        </div>
      )
    }
    if (document.referrer.includes(window.location.origin)) {
      return (
        <div className={Styles.backButton}>
          <button type="button" onClick={history.goBack}>
            ← Takaisin
          </button>
        </div>
      )
    }
    return null
  }

  render() {
    const { loading, branch } = this.props

    return (
      <div className={[Styles.pageContent, Styles.companyScreen].join(" ")}>
        {loading ? (
          <div className={Styles.loadingContainer}>
            <LoadingSpinner loading={loading} />
          </div>
        ) : (
          <div>
            {this.renderBackButton()}
            {this.renderBranch()}
          </div>
        )}
        <Seo title={`Sivutoimipaikka "${branch.virallinen_nimi}"`} />
      </div>
    )
  }
}

Branch.propTypes = {
  loading: PropTypes.bool.isRequired,
  branch: PropTypes.shape().isRequired,
  match: PropTypes.shape().isRequired,
  getBranch: PropTypes.func.isRequired,
  location: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
}

Branch.contextTypes = {
  router: PropTypes.shape(),
}

const mapStateToProps = state => ({
  branch: state.branch.data,
  loading: state.branch.loading,
})

const mapDispatchToProps = dispatch => ({
  getBranch: businessId => dispatch(fetchBranch(businessId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Branch))
